<template>
  <v-container fluid>
    <confirm-dialog v-model="removePromiseGetter"/>
    <v-dialog v-model="dialog" width="1000px" persistent>
      <v-card>
        <v-card-text class="pt-8">
          <custom-form
              dense
              v-model="valid"
              :model="model"
              :fields="fields"
              @change="model = $event"
          >
            <template v-slot:fields>
              <div>
                <div v-for="(field, i) in model.fields">
                  <custom-form
                      dense
                      v-model="valid"
                      :model="field"
                      :fields="fieldsInfo"
                      @change="field = $event"
                  />
                </div>
                <div class="d-flex justify-center">
                  <v-btn color="primary" text dense @click="addField">
                    add field
                  </v-btn>
                </div>
              </div>
            </template>
          </custom-form>
          <v-card-actions class="d-flex justify-center">
            <v-btn color="primary" outlined @click="dialog = false">cancel</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="save">save</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        :loading="loading"
        :search="search"
        class="elevation-3"
        item-key="id"
        hide-default-footer
        multi-sort
    >
      <template v-slot:top>
        <v-toolbar flat class="pa-0">
          <v-spacer/>
          <v-btn color="primary" @click="editItem">create payment method</v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:item.fields="{ item }">
        <v-chip color="primary" outlined label>
          {{ item.fields.length }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="text-right">
          <v-btn color="primary" fab x-small class="mx-2" @click="editItem(item)">
            <v-icon small>edit</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <v-pagination
        class="mt-2"
        v-model="page"
        :length="pageCount"
    ></v-pagination>
  </v-container>
</template>

<script>
export default {
  name: "Formation",
  data: () => ({
    valid: false,
    model: {
      fields: []
    },
    page: 1,
    dialog: false,
    pageCount: 0,
    loading: false,
    itemsPerPage: 500,
    filterByClient: null,
    search: "",
    data: [],
    headers: [
      {text: 'id', value: 'paymentMethodId'},
      {text: 'name', value: 'name'},
      {text: 'fields', value: 'fields'},
      {text: '', value: 'actions', sortable: false},
    ],
    removePromiseGetter: null,
  }),
  methods: {
    addField() {
      this.model.fields.push(
          {
            contentType: "",
            fieldType: "",
            required: false,
            validate: false,
          }
      )
    },
    searchData(data) {
      this.$http.get(`/formation/search?query=${data}`)
          .then(r => {
            this.pageCount = 1;
            this.itemsPerPage = 999999
            this.data = r.data
          }, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
    },
    editItem(item) {
      if (!!item?.id) this.model = {...item}
      else this.model = {
        fields: []
      }

      this.dialog = true;
    },
    save() {
      if (!this.model?.id) {
        this.$http.post('/payment-methods', this.model)
            .then(r => this.init(), e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
      } else {
        this.$http.put('/payment-methods', this.model)
            .then(r => this.init(), e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
      }

    },
    init() {
      this.dialog = false;
      this.itemsPerPage = 500
      this.$http.get('/payment-methods')
          .then(r => this.data = r.data, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
    }
  },
  computed: {
    fields() {
      return {
        name: {
          cols: 6,
          type: String,
          label: 'Name',
          rules: [this.$rule.required],
          disabled: !!this.model?.id
        },
        description: {
          cols: 6,
          type: String,
          label: 'Description',
        },
        fields: {}
      }
    },
    fieldsInfo() {
      return {
        contentType: {
          cols: 3,
          type: Array,
          items: this.contentType,
          label: 'Content type',
          text: 'description',
          hideDetails: true
        },
        fieldType: {
          cols: 3,
          type: Array,
          label: 'Field type',
          items: this.fieldType,
          text: 'description',
          hideDetails: true
        },
        name: {
          cols: 2,
          type: String,
          label: 'Name',
          hideDetails: true
        },
        required: {
          cols: 2,
          type: Boolean,
          switch: true,
          label: 'Required',
          hideDetails: true
        },
        validate: {
          cols: 2,
          type: Boolean,
          switch: true,
          label: 'Validate',
          hideDetails: true
        },
        fields: {}
      }
    },
  },
  mounted() {
    this.init();
    this.$http.get('/payment-methods/content-type')
        .then(r => this.contentType = r.data, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
    this.$http.get('/payment-methods/field-type')
        .then(r => this.fieldType = r.data, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
  }
}
</script>

<style scoped>

</style>